import React, { useEffect, useState } from 'react';
import { fetchStaffMembers, fetchStaffShifts, createShift, updateShift } from '../../../../../../../Utilities/api/index.js';

function StaffAndSchedule() {
  var _useState1 = useState([]), staff = _useState1[0], setStaff = _useState1[1];
  var _useState2 = useState([]), todaysShifts = _useState2[0], setTodaysShifts = _useState2[1];
  var _useState3 = useState(null), selectedStaff = _useState3[0], setSelectedStaff = _useState3[1];
  var _useState4 = useState([]), selectedStaffShifts = _useState4[0], setSelectedStaffShifts = _useState4[1];
  var _useState5 = useState(false), loading = _useState5[0], setLoading = _useState5[1];
  var _useState6 = useState(''), errorMsg = _useState6[0], setErrorMsg = _useState6[1];
  var _useState7 = useState(''), infoMsg = _useState7[0], setInfoMsg = _useState7[1];

  // Add Shift form state
  var _useState8 = useState({
    userId: '',
    date: getTodayISO(),
    startTime: '09:00',
    endTime: '',
    shiftType: '',
    notes: ''
  }), form = _useState8[0], setForm = _useState8[1];

  useEffect(function () {
    setLoading(true);
    fetchStaffMembers()
      .then(function (list) {
        var safe = Array.isArray(list) ? list : [];
        // Keep only non-customer roles
        var filtered = safe.filter(function (u) {
          var r = (u && u.job) ? String(u.job).toLowerCase() : '';
          return r && r !== 'customer';
        });
        setStaff(filtered);

        // Build today's schedule (fetch shifts for each staff; fine for MVP)
        var promises = filtered.map(function (u) {
          return fetchStaffShifts(u.id).then(function (shifts) {
            var today = new Date().toISOString().split('T')[0];
            var todays = (Array.isArray(shifts) ? shifts : []).filter(function (s) {
              var d = toLocalISODate(s.clockIn);
              return d === today;
            }).map(function (s) {
              return attachUser(s, u);
            });
            return todays;
          }).catch(function () { return []; });
        });

        return Promise.all(promises);
      })
      .then(function (allTodays) {
        var flat = [];
        for (var i = 0; i < allTodays.length; i++) {
          var arr = allTodays[i] || [];
          for (var j = 0; j < arr.length; j++) flat.push(arr[j]);
        }
        // sort by clockIn asc
        flat.sort(function (a, b) {
          var at = new Date(a.clockIn).getTime();
          var bt = new Date(b.clockIn).getTime();
          return at - bt;
        });
        setTodaysShifts(flat);
      })
      .catch(function (err) {
        setErrorMsg('Failed to load staff or shifts.');
        console.error(err);
      })
      .finally(function () { setLoading(false); });
  }, []);

  function attachUser(shift, user) {
    var s = Object.assign({}, shift);
    s._user = {
      id: user.id,
      username: user.username,
      job: user.job,
      email: user.email
    };
    return s;
  }

  function toLocalISODate(ts) {
    try {
      if (!ts) return '';
      var d = new Date(ts);
      if (isNaN(d.getTime())) return '';
      return d.toISOString().split('T')[0];
    } catch (e) {
      return '';
    }
  }

  function formatHM(ts) {
    try {
      if (!ts) return '';
      var d = new Date(ts);
      if (isNaN(d.getTime())) return '';
      var h = d.getHours();
      var m = d.getMinutes();
      var hh = (h < 10 ? '0' + h : '' + h);
      var mm = (m < 10 ? '0' + m : '' + m);
      return hh + ':' + mm;
    } catch (e) {
      return '';
    }
  }

  function getTodayISO() {
    var d = new Date();
    var y = d.getFullYear();
    var m = d.getMonth() + 1;
    var day = d.getDate();
    var mm = m < 10 ? '0' + m : '' + m;
    var dd = day < 10 ? '0' + day : '' + day;
    return y + '-' + mm + '-' + dd;
  }

  function onSelectStaff(e) {
    var id = e && e.target ? e.target.value : '';
    setSelectedStaff(null);
    setSelectedStaffShifts([]);
    if (!id) return;

    var found = null;
    for (var i = 0; i < staff.length; i++) {
      if (String(staff[i].id) === String(id)) { found = staff[i]; break; }
    }
    setSelectedStaff(found);

    if (found) {
      setLoading(true);
      fetchStaffShifts(found.id)
        .then(function (shifts) {
          var safe = Array.isArray(shifts) ? shifts : [];
          // show latest first
          safe.sort(function (a, b) {
            var at = new Date(a.clockIn).getTime();
            var bt = new Date(b.clockIn).getTime();
            return bt - at;
          });
          setSelectedStaffShifts(safe.slice(0, 20));
        })
        .catch(function () { setErrorMsg('Failed to load shifts for staff.'); })
        .finally(function () { setLoading(false); });
    }
  }

  function onFormChange(key, val) {
    setForm(function (prev) {
      var next = Object.assign({}, prev);
      next[key] = val;
      return next;
    });
  }

  function combineDateTime(dateStr, hm) {
    try {
      if (!dateStr || !hm) return null;
      var parts = hm.split(':');
      var h = parseInt(parts[0], 10);
      var m = parseInt(parts[1], 10);
      var d = new Date(dateStr + 'T00:00:00');
      d.setHours(h);
      d.setMinutes(m);
      return d.toISOString();
    } catch (e) {
      return null;
    }
  }

  function submitAddShift(e) {
    if (e && e.preventDefault) e.preventDefault();
    setErrorMsg('');
    setInfoMsg('');

    if (!form.userId || !form.date || !form.startTime) {
      setErrorMsg('Please select staff, date, and start time.');
      return;
    }

    var clockInISO = combineDateTime(form.date, form.startTime);
    var clockOutISO = form.endTime ? combineDateTime(form.date, form.endTime) : null;

    var payload = {
      userId: parseInt(form.userId, 10),
      clockIn: clockInISO,
      clockOut: clockOutISO,
      shiftType: form.shiftType || '',
      notes: form.notes || ''
    };

    setLoading(true);
    createShift(payload)
      .then(function (created) {
        setInfoMsg('Shift added.');
        // If this is for the selected user, refresh their list
        if (selectedStaff && String(selectedStaff.id) === String(form.userId)) {
          return fetchStaffShifts(selectedStaff.id).then(function (shifts) {
            var safe = Array.isArray(shifts) ? shifts : [];
            safe.sort(function (a, b) {
              var at = new Date(a.clockIn).getTime();
              var bt = new Date(b.clockIn).getTime();
              return bt - at;
            });
            setSelectedStaffShifts(safe.slice(0, 20));
          });
        }
      })
      .catch(function (err) {
        setErrorMsg('Failed to add shift.');
        console.error(err);
      })
      .finally(function () { setLoading(false); });
  }

  function clockOutNow(shift) {
    if (!shift || !shift.id) return;
    if (shift.clockOut) {
      setInfoMsg('This shift is already clocked out.');
      return;
    }
    setLoading(true);
    var payload = { clockOut: new Date().toISOString() };
    updateShift(shift.id, payload)
      .then(function () {
        setInfoMsg('Clocked out.');
        // Update selected view
        if (selectedStaff) {
          return fetchStaffShifts(selectedStaff.id).then(function (shifts) {
            var safe = Array.isArray(shifts) ? shifts : [];
            safe.sort(function (a, b) {
              var at = new Date(a.clockIn).getTime();
              var bt = new Date(b.clockIn).getTime();
              return bt - at;
            });
            setSelectedStaffShifts(safe.slice(0, 20));
          });
        }
      })
      .catch(function (err) {
        setErrorMsg('Failed to clock out.');
        console.error(err);
      })
      .finally(function () { setLoading(false); });
  }

  return (
    <div style={{ padding: '1rem' }}>
      <h2 style={{ marginBottom: '0.5rem' }}>Staff & Scheduling</h2>
      <p style={{ marginTop: 0, color: '#666' }}>See who is on today, add shifts, and clock people out.</p>

      {errorMsg ? <div style={{ color: '#b00020', marginBottom: '0.5rem' }}>{errorMsg}</div> : null}
      {infoMsg ? <div style={{ color: '#0b8043', marginBottom: '0.5rem' }}>{infoMsg}</div> : null}
      {loading ? <div>Loading…</div> : null}

      {/* Who's On Today */}
      <div style={{ marginTop: '1rem', marginBottom: '1rem', border: '1px solid #eee', borderRadius: 8, padding: '0.75rem' }}>
        <div style={{ fontWeight: 600, marginBottom: '0.5rem' }}>Who’s On Today</div>
        {todaysShifts.length === 0 ? (
          <div>No shifts found for today.</div>
        ) : (
          <div style={{ display: 'grid', gap: '8px' }}>
            {todaysShifts.map(function (s) {
              var u = s._user || {};
              return (
                <div key={s.id} style={{ border: '1px solid #ddd', borderRadius: 6, padding: '0.5rem' }}>
                  <div><strong>{u.username || 'Unknown'}</strong> — {u.job || 'staff'}</div>
                  <div>In: {formatHM(s.clockIn)}{s.clockOut ? (' • Out: ' + formatHM(s.clockOut)) : ' • (on shift)'}</div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Staff Browser */}
      <div style={{ marginBottom: '1rem', border: '1px solid #eee', borderRadius: 8, padding: '0.75rem' }}>
        <div style={{ fontWeight: 600, marginBottom: '0.5rem' }}>Browse Staff</div>
        <select
          value={selectedStaff && selectedStaff.id ? String(selectedStaff.id) : ''}
          onChange={onSelectStaff}
          style={{ width: 280, padding: '8px', borderRadius: 6, border: '1px solid #ccc' }}
        >
          <option value="">Select staff member…</option>
          {staff.map(function (u) {
            return (
              <option key={u.id} value={String(u.id)}>
                {u.username} ({u.job || 'staff'})
              </option>
            );
          })}
        </select>

        {/* Selected Staff Shifts */}
        {selectedStaff ? (
          <div style={{ marginTop: '0.75rem' }}>
            <div style={{ fontWeight: 600, marginBottom: '0.25rem' }}>
              Recent Shifts — {selectedStaff.username}
            </div>
            {selectedStaffShifts.length === 0 ? (
              <div>No shifts found.</div>
            ) : (
              <div style={{ display: 'grid', gap: '8px' }}>
                {selectedStaffShifts.map(function (s) {
                  var onShift = !s.clockOut;
                  return (
                    <div key={s.id} style={{ border: '1px solid #ddd', borderRadius: 6, padding: '0.5rem' }}>
                      <div>
                        {toLocalISODate(s.clockIn)} — {s.shiftType || 'general'}
                      </div>
                      <div>
                        In: {formatHM(s.clockIn)}{s.clockOut ? (' • Out: ' + formatHM(s.clockOut)) : ' • (on shift)'}
                      </div>
                      {s.notes ? <div style={{ color: '#666' }}>Notes: {s.notes}</div> : null}
                      {onShift ? (
                        <button
                          onClick={function () { clockOutNow(s); }}
                          style={{ marginTop: '6px', padding: '6px 10px', borderRadius: 6, border: '1px solid #aaa', cursor: 'pointer' }}
                        >
                          Clock Out Now
                        </button>
                      ) : null}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        ) : null}
      </div>

      {/* Add Shift */}
      <div style={{ border: '1px solid #eee', borderRadius: 8, padding: '0.75rem' }}>
        <div style={{ fontWeight: 600, marginBottom: '0.5rem' }}>Add Shift</div>
        <form onSubmit={submitAddShift}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', maxWidth: 720 }}>
            <div>
              <label style={{ display: 'block', marginBottom: 4 }}>Staff</label>
              <select
                value={form.userId}
                onChange={function (e) { onFormChange('userId', e.target.value); }}
                style={{ width: '100%', padding: '8px', borderRadius: 6, border: '1px solid #ccc' }}
              >
                <option value="">Select…</option>
                {staff.map(function (u) {
                  return <option key={u.id} value={String(u.id)}>{u.username} ({u.job || 'staff'})</option>;
                })}
              </select>
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: 4 }}>Date</label>
              <input
                type="date"
                value={form.date}
                onChange={function (e) { onFormChange('date', e.target.value); }}
                style={{ width: '100%', padding: '8px', borderRadius: 6, border: '1px solid #ccc' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: 4 }}>Start Time</label>
              <input
                type="time"
                value={form.startTime}
                onChange={function (e) { onFormChange('startTime', e.target.value); }}
                required
                style={{ width: '100%', padding: '8px', borderRadius: 6, border: '1px solid #ccc' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: 4 }}>End Time (optional)</label>
              <input
                type="time"
                value={form.endTime}
                onChange={function (e) { onFormChange('endTime', e.target.value); }}
                style={{ width: '100%', padding: '8px', borderRadius: 6, border: '1px solid #ccc' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: 4 }}>Shift Type</label>
              <select
                value={form.shiftType}
                onChange={function (e) { onFormChange('shiftType', e.target.value); }}
                style={{ width: '100%', padding: '8px', borderRadius: 6, border: '1px solid #ccc' }}
              >
                <option value="">General</option>
                <option value="frontdesk">Front Desk</option>
                <option value="grooming">Grooming</option>
                <option value="training">Training</option>
                <option value="daycare">Daycare</option>
                <option value="admin">Admin</option>
              </select>
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: 4 }}>Notes</label>
              <input
                type="text"
                value={form.notes}
                onChange={function (e) { onFormChange('notes', e.target.value); }}
                placeholder="Optional"
                style={{ width: '100%', padding: '8px', borderRadius: 6, border: '1px solid #ccc' }}
              />
            </div>
          </div>

          <div style={{ marginTop: '10px' }}>
            <button
              type="submit"
              style={{ padding: '8px 14px', borderRadius: 6, border: '1px solid #999', cursor: 'pointer' }}
            >
              Add Shift
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default StaffAndSchedule;
